import { jsonResponseHandling } from '../fetch';
import cache from '../cache';
import {
    apiUrl,
    STATIC_PATH,
    GTFS_STATIC_PATH,
    HEALTH_PATH,
    fetchWithSubscriptionKey,
} from '../api-manager';

export const getStopsByRoute = routeId => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/gtfs/route/${routeId}/stops`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getRoutesByStop = stopCode => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/shapes?stop_code=${stopCode}`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getAllStops = serviceDate => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/stops?${serviceDate ? new URLSearchParams({ date: serviceDate }).toString() : ''}`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getAllStopTypes = () => fetchWithSubscriptionKey(
    apiUrl(`${GTFS_STATIC_PATH}/gtfs/stopstypes/`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getTripById = tripId => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/trip?trip_id=${tripId}`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getTripHeadsignById = tripId => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/trip/${tripId}/headsign`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

export const getRoutesByShortName = (routeShortName, date) => fetchWithSubscriptionKey(
    date
        ? apiUrl(`${STATIC_PATH}/trips?route_short_name=${routeShortName}&date=${date}`)
        : apiUrl(`${STATIC_PATH}/trips?route_short_name=${routeShortName}`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response)).then(routes => (routes.length && routes) || []);

export const getHealthMonitorData = () => fetchWithSubscriptionKey(
    apiUrl(`${HEALTH_PATH}/healthmonitor/all`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

const fetchAllRoutes = () => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/routes`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));

const tokenizeRoutes = routes => routes.map(route => ({
    ...route,
    tokens: route.route_short_name.toLowerCase().split(' '),
}));

export const getAllRoutes = () => fetchAllRoutes()
    .then((routes) => {
        const tokenizedRoutes = tokenizeRoutes(routes);
        return cache.routes.clear()
            .then(() => cache.routes.bulkAdd(tokenizedRoutes))
            .then(() => tokenizedRoutes);
    })
    .catch((error) => {
        cache.routes.clear();
        throw error;
    });

export const geoSearch = (body, searchEntityType) => {
    const url = apiUrl(`${STATIC_PATH}/gtfs/geosearch/${searchEntityType}`);
    return fetchWithSubscriptionKey(
        url,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        },
    ).then(response => jsonResponseHandling(response));
};

export const getRailHeadsignsStops = includeNewStops => fetchWithSubscriptionKey(
    apiUrl(`${STATIC_PATH}/operational/rail/headsigns?include_new_crl_stations=${includeNewStops}`),
    { method: 'GET' },
).then(response => jsonResponseHandling(response));
